import { API } from './resources'

export default {
  createProjectNominations: (projectID, data) => {
    return API.put(`/projects/${projectID}/createNominations`, data)
  }
}
